export const environment = {
  production: true,
  buildId: '3437290285722131',
  configFile: 'config.json',
};
